import React from "react";
import { ArrowRight, Shirt, Building2 } from "lucide-react";

export default function BusinessBanner() {
  return (
    <section className="bg-[color:var(--dms-navy)] py-24">
      <div className="max-w-4xl mx-auto px-5 lg:px-8 text-center">
        <p className="kicker">For business</p>
        <h2 className="font-serif text-4xl md:text-5xl text-white mt-4">Your brand. Your apparel.</h2>
        <div className="w-14 h-[2px] bg-[color:var(--dms-peach)] mx-auto mt-5" />
        <p className="mt-6 text-white/70 leading-relaxed">
          From business polos to team shirts, create professional apparel made for your organization. We print your logo, keep it consistent across every size, and reorder it the same way next year.
        </p>
        <div className="mt-10">
          <a href="#custom" className="btn-peach">Start a custom order <ArrowRight className="w-4 h-4" /></a>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-5 lg:px-8 mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 hover-lift">
          <div className="w-12 h-12 rounded-full bg-[color:var(--dms-peach)] flex items-center justify-center">
            <Shirt className="w-5 h-5 text-[color:var(--dms-navy)]" />
          </div>
          <h3 className="font-serif text-2xl text-white mt-5">Shop our Christian collection</h3>
          <p className="text-white/70 mt-3 leading-relaxed">Our own faith-based designs, already drawn and ready to print. Choose a shirt, a color and a size — that's the whole job.</p>
          <a href="#tshirts" className="link-peach mt-6 inline-flex">Browse the collection <ArrowRight className="w-4 h-4" /></a>
        </div>
        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 hover-lift">
          <div className="w-12 h-12 rounded-full bg-[color:var(--dms-peach)] flex items-center justify-center">
            <Building2 className="w-5 h-5 text-[color:var(--dms-navy)]" />
          </div>
          <h3 className="font-serif text-2xl text-white mt-5">Custom apparel</h3>
          <p className="text-white/70 mt-3 leading-relaxed">For businesses, churches, ministries, organizations, teams, events, groups and individuals. Your logo, your words, your garment.</p>
          <a href="#custom" className="link-peach mt-6 inline-flex">Request custom apparel <ArrowRight className="w-4 h-4" /></a>
        </div>
      </div>
    </section>
  );
}
